import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OrganizationSetting from "@/services/organization/organization-setting";
import { useStore } from "vuex";
import { computed } from "vue";

export function useUpdateParentTemplateFolderOrder() {
  const store = useStore();
  const queryClient = useQueryClient();
  const account = computed(() => store.getters.account.data);
  const organizationId = computed(() => account.value?.organizationId);

  return useMutation({
    mutationFn: async (parentTemplateFolderOrder: string[]) => {
      const result =
        await OrganizationSetting.updateParentTemplateFolderOrder(parentTemplateFolderOrder);

      if (result.data.status) {
        return result.data.data;
      }

      throw new Error(result.data.msg || "Failed to update parent template folder order");
    },
    onSuccess: () => {
      // Invalidate and refetch parent template folders
      if (organizationId.value) {
        queryClient.invalidateQueries({
          queryKey: ["parentTemplateFolders", organizationId.value],
        });
      }
    },
  });
}
